import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/reservation-action-types';

import type {Map} from 'immutable';
import type {ActionsMap} from 'redux-store';

export type ReservationStore = {
    reservation: Map<unknown, unknown>;
};

const initialState = (): ReservationStore => {
    return {
        reservation: Immutable.Map(),
    };
};

const actionsMap: ActionsMap<ReservationStore> = {
    [actionTypes.GET_RESERVATION_SUCCESS]: (state, action) => {
        return {
            reservation: action.data,
        };
    },
    [actionTypes.DISPOSE]: () => {
        return initialState();
    },
};

export default createReducer<ReservationStore>(initialState(), actionsMap);
